export default __webpack_public_path__ + "static/media/skylight.6b2ac364.svg";